//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    category: { type: Object, required: true },
    hideHeader: { type: Boolean, default: false }
  },
  methods: {
    expand (articleId) {
      this.$refs[`article${articleId}`][0].expand()
    }
  }
}
